import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ImportMemberPage = Loadable(
  lazy(() => import("features/importMember/components/Page"))
);

const routes = {
  path: "importMember",
  children: [
    { path: "", element: <ImportMemberPage /> },
  ],
};

export default routes;
